<template>

    <div class="flex flex-col items-center w-full h-full rounded-lg bg-white border-pink-800 border-2 my-1 lg:my-3 px-1 lg:px-2">

        <div class="absolute" v-if="loading">
                
            <ring-loader class="rounded-full bg-red-500" ></ring-loader> 
        </div>

        <div>
            <div class="flex flex-col items-center rounded overflow-hidden shadow w-full mt-2 lg:mt-5">

                <div class="flex justify-center content-center w-20 lg:w-1/2 h-12 lg:h-24">

                    <img v-if="myBusiness.logo!=''" :src="myBusiness.logo" class="object-contain rounded-full bg-white h-20 lg:h-32">	

                    <img v-else :src="myBusiness.brand.logo" class="object-contain bg-white w-full h-16 lg:h-32">	
                </div>

                <div class="flex flex-col lg:flex-row items-baseline text-center mt-10  lg:mt-16">
                    
                    <div class="flex justify-around items-baseline">

                        <div class="w-20 mr-1 lg:mr-0">
                            
                            <h3 class="text-black text-xs lg:text-sm font-extrabold font-sans" >
                            <p class="text-pink-800">{{$t('business.clientName')}}</p> </h3>
                        </div>

                        <div class="mr-1 my-1 lg:my-4 lg:mr-0 flex">
                            
                            <h3>
                            <p class="w-full self-center h-8 lg:h-12 lg:w-64 border-pink-800 border-2 px-2 lg:px-4 lg:border-4 rounded">
                            {{myBusiness.name}} </p></h3>
                        </div>
                    </div>

                    <div class="flex items-baseline" >
                        
                        <div class="w-20 ml-1 lg:ml-0">
                            <h4 class="text-black text-xs lg:text-sm font-extrabold font-sans lg:px-1">
                            <p class="text-purple-800">{{$t('brand.contact')}} </p></h4>                    
                        </div>
                    
                        <div class="ml-1 lg:ml-0">
                            <a :href="`tel:${myBusiness.phone}`">
                            <p class="border border-black px-1 mt-2 text-blue-700 font-bold rounded lg:rounded-full">{{myBusiness.phone}}</p>
                            </a>                    
                        </div>
                    </div>
    
                </div>

                    <div class="flex content-around justify-around rounded rounded-t-lg overflow-hidden mt-4 lg:mt-1 w-full">

                        <button 
                        class="myPageCard"
                        @click="showInfoMethod(myBusiness)"> {{$t('search.goToPage')}} </button>
                    </div>

            </div>
        </div>
    </div>
</template>

<script>

// import myMethods from '../../classes/componentsMethods'


export default {

    created(){

        // console.log(`my class of ${this.index} is ${JSON.stringify(this.myClass)}`);
    },

    props:{
        
        myBusiness: {
            
            type: Object,
        },

        showInfoMethod: {

            type: Function
        },

        showSessionsMethod: {

            type: Function
        },

        index: 0
    },

    components:{

    },

    methods:{

        callNumber(){

            window.open(`tel:${this.myBusiness.phone}`);
        },
    },

    data: function(){

        return {

            loading: false
        }
    }
}
</script>

<style>

</style>